/* IMPORT */
import { SYMBOL_STORE } from '../symbols.js';
import { isObject } from '../utils.js';
/* MAIN */
const isStore = (value) => {
    return isObject(value) && (SYMBOL_STORE in value);
};
/* EXPORT */
export default isStore;
